import type { FormField, FormSchema } from '@cli-types/core-engine/schema.js'
import type { SchemaMetadata } from '@cli-types/next-adapter/commands.js'
import { createFormTitleField } from './create-form-title-field.js'
import { promptAdditionalFormFields } from './prompt-additional-form-fields.js'

export async function createFormSchema(
  metadata: SchemaMetadata,
  schemasDir: string
): Promise<FormSchema> {
  const titleField = createFormTitleField(metadata.titleLabel)
  const schema: FormSchema = {
    name: metadata.name,
    type: 'form',
    label: metadata.label,
    description: metadata.description,
    icon: metadata.icon
  }

  const fields: FormField[] = [titleField]
  await promptAdditionalFormFields(schemasDir, fields)
  schema.fields = fields
  return schema
}
